import { DataManager } from "../model/DataManager.js";
import { VOCategory, VOVideo } from "../model/DataStructure.js";
import { IVideoSelector, VideoSelector } from "./VideoSelector.js";

export class MultiVideoSelector implements IVideoSelector {
    public onSelectVideo = e5.Signal.create<[VOVideo]>();

    public element: HTMLDivElement;

    private _category: VOCategory = null;
    private _items: MultiVideoSelectorItem[] = [];
    private _current: MultiVideoSelectorItem = null;
    private _video: VOVideo = null;

    constructor(private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.classList.add("multi-video-selector");

        for (var category of this._data.config.categories) {
            var item = new MultiVideoSelectorItem(category, this._data);
            this.element.appendChild(item.element);
            item.onSelectVideo.add((video) => this.onSelectVideo.dispatch(video));
            this._items.push(item);
        }

        this.category = this._items[0].category;
    }

    public set category(value: VOCategory) {
        if (!value || this._category == value) {
            return;
        }
        this._category = value;

        if (this._current) {
            this._current.active = false;
        }

        this._current = null;
        for (var item of this._items) {
            if (item.category == value) {
                this._current = item;
                break;
            }
        }

        if (this._current) {
            this._current.active = true;
        }
    }

    public get category(): VOCategory {
        return this._category;
    }

    public get video(): VOVideo {
        return this._video;
    }

    public set video(value: VOVideo) {
        if (this._video == value) {
            return;
        }
        this._video = value;

        for (var item of this._items) {
            item.selector.video = this._video;
        }
    }
}

class MultiVideoSelectorItem {
    public onSelectVideo = e5.Signal.create<[VOVideo]>();

    public element: HTMLDivElement;
    public selector: VideoSelector;

    constructor(public category: VOCategory, private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.classList.add("multi-video-selector-list");

        this.selector = new VideoSelector(category.videos, this._data);
        this.element.appendChild(this.selector.element);

        this.selector.onSelectVideo.add((video) => this.onSelectVideo.dispatch(video));
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(value: boolean) {
        this.element.classList.toggle("active", value);
    }
}